import { type IFlowAction } from 'widgets/Flow'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type.ts'

export const getChildActionsByIdAndType = ({
  id,
  getActionById,
  type,
}: {
  id: string
  getActionById: (id: string) => IFlowAction | undefined
  type: ISmartCallFlowActionType
}) => {
  const actions: IFlowAction[] = []
  const findAction = (id: string) => {
    const action = getActionById(id)
    if (!action) return
    if (action.actionStore.type === type) {
      actions.push(action)
    }
    action.actionStore.nextIds.forEach(findAction)
  }
  findAction(id)
  return actions
}
